export default "__VITE_ASSET__FZrFGDyH__"